import { CalendarDayInterface } from '../../utils';
import { ActionRef, ActionTransactionSubType, ActionType } from '../action';
import { AllocationRule } from '../allocations';
import {
  CarriedInterestDayCountFormat,
  CarriedInterestFeeAllocationMethod,
  CarriedInterestFeeTemplate,
  WaterfallStructure,
} from '../carry-settings';
import { TransactionOperation } from '../transaction';
import { EqualisationInterestFeeTemplate } from '../equalisation-settings';
import { ClassificationFlow } from '../investor-classification';
import { KycRequestProcess } from '../kyc';
import { KybRequestProcess } from '../kyb';

export enum CurrencyCode {
  AUD = 'AUD',
  GBP = 'GBP',
  CAD = 'CAD',
  EUR = 'EUR',
  HKD = 'HKD',
  JPY = 'JPY',
  NZD = 'NZD',
  CHF = 'CHF',
  USD = 'USD',
  CNY = 'CNY',
  AFN = 'AFN',
  ALL = 'ALL',
  DZD = 'DZD',
  AOA = 'AOA',
  ARS = 'ARS',
  AMD = 'AMD',
  AWG = 'AWG',
  AZN = 'AZN',
  BSD = 'BSD',
  BHD = 'BHD',
  BDT = 'BDT',
  BBD = 'BBD',
  BYN = 'BYN',
  BZD = 'BZD',
  BMD = 'BMD',
  BTN = 'BTN',
  BOB = 'BOB',
  BAM = 'BAM',
  BWP = 'BWP',
  BRL = 'BRL',
  BND = 'BND',
  BGN = 'BGN',
  MMK = 'MMK',
  BIF = 'BIF',
  KHR = 'KHR',
  CVE = 'CVE',
  KYD = 'KYD',
  XAF = 'XAF',
  XPF = 'XPF',
  CLP = 'CLP',
  COP = 'COP',
  KMF = 'KMF',
  CDF = 'CDF',
  CRC = 'CRC',
  CUP = 'CUP',
  CZK = 'CZK',
  DKK = 'DKK',
  DJF = 'DJF',
  DOP = 'DOP',
  XCD = 'XCD',
  EGP = 'EGP',
  ERN = 'ERN',
  ETB = 'ETB',
  FKP = 'FKP',
  FJD = 'FJD',
  GMD = 'GMD',
  GEL = 'GEL',
  GHS = 'GHS',
  GIP = 'GIP',
  GTQ = 'GTQ',
  GNF = 'GNF',
  GYD = 'GYD',
  HTG = 'HTG',
  HNL = 'HNL',
  HUF = 'HUF',
  ISK = 'ISK',
  INR = 'INR',
  IDR = 'IDR',
  IRR = 'IRR',
  IQD = 'IQD',
  ILS = 'ILS',
  JMD = 'JMD',
  JOD = 'JOD',
  KZT = 'KZT',
  KES = 'KES',
  KWD = 'KWD',
  KGS = 'KGS',
  LAK = 'LAK',
  LBP = 'LBP',
  LSL = 'LSL',
  LRD = 'LRD',
  LYD = 'LYD',
  MOP = 'MOP',
  MKD = 'MKD',
  MGA = 'MGA',
  MWK = 'MWK',
  MYR = 'MYR',
  MVR = 'MVR',
  MRU = 'MRU',
  MUR = 'MUR',
  MXN = 'MXN',
  MDL = 'MDL',
  MNT = 'MNT',
  MAD = 'MAD',
  MZN = 'MZN',
  NAD = 'NAD',
  NPR = 'NPR',
  ANG = 'ANG',
  TWD = 'TWD',
  NIO = 'NIO',
  NGN = 'NGN',
  KPW = 'KPW',
  NOK = 'NOK',
  OMR = 'OMR',
  PKR = 'PKR',
  PAB = 'PAB',
  PGK = 'PGK',
  PYG = 'PYG',
  PEN = 'PEN',
  PHP = 'PHP',
  PLN = 'PLN',
  QAR = 'QAR',
  RON = 'RON',
  RUB = 'RUB',
  RWF = 'RWF',
  SHP = 'SHP',
  WST = 'WST',
  STN = 'STN',
  SAR = 'SAR',
  RSD = 'RSD',
  SCR = 'SCR',
  SLE = 'SLE',
  SGD = 'SGD',
  SBD = 'SBD',
  SOS = 'SOS',
  ZAR = 'ZAR',
  KRW = 'KRW',
  SSP = 'SSP',
  LKR = 'LKR',
  SDG = 'SDG',
  SRD = 'SRD',
  SZL = 'SZL',
  SEK = 'SEK',
  SYP = 'SYP',
  TJS = 'TJS',
  TZS = 'TZS',
  THB = 'THB',
  TOP = 'TOP',
  TTD = 'TTD',
  TND = 'TND',
  TRY = 'TRY',
  TMT = 'TMT',
  UGX = 'UGX',
  UAH = 'UAH',
  AED = 'AED',
  UYU = 'UYU',
  UZS = 'UZS',
  VUV = 'VUV',
  VES = 'VES',
  VND = 'VND',
  XOF = 'XOF',
  YER = 'YER',
  ZMW = 'ZMW',
  ZWG = 'ZWG',
  ZWL = 'ZWL',
}

export enum FxDataFeed {
  CurrencyLayer = 'CurrencyLayer', // https://currencylayer.com/
}

export enum ForeignCurrencyCostRateCalculationType {
  Average = 'average cost',
}

export enum VehicleJurisdiction {
  CaymanIslands = 'Cayman Islands',
  DelawareUS = 'Delaware (US)',
  EnglandUK = 'England (UK)',
  Guernsey = 'Guernsey',
  HongKong = 'Hong Kong',
  Ireland = 'Ireland',
  Jersey = 'Jersey',
  Luxembourg = 'Luxembourg',
  Scotland = 'Scotland',
  Singapore = 'Singapore',
}

export enum CommitmentType {
  CapitalOnly = 'CapitalOnly',
  LoanOnly = 'LoanOnly',
  CapitalAndLoan = 'CapitalAndLoan',
}

export enum CapitalContributionRule {
  FixedCommitmentPercentage = 'FixedCommitmentPercentage',
  ProRataOfFixedPartnershipCapital = 'ProRataOfFixedPartnershipCapital',
  Manual = 'Manual',
}

export interface AccountMapping {
  actionRef: ActionRef;
  actionType: ActionType;
  customActionTypeId?: string | null;
  customActionType?: string | null;
  isInUse?: boolean;
  transactionTypes: Array<{
    transactionTypeId: string;
    transactionSubType: ActionTransactionSubType;
    operationType: TransactionOperation;
  }>;
}

export interface Vehicle {
  _id: string;
  lpFirmId: string;
  vehicleName: string;
  baseCurrency: CurrencyCode;
  fxDataFeed: FxDataFeed;
  foreignCurrencyCostRateCalculation: ForeignCurrencyCostRateCalculationType;
  firstInvestmentDate: CalendarDayInterface | null;
  defaultAllocationRule: AllocationRule;
  financialYearEndDay: number;
  financialYearEndMonth: number;
  commitmentType: CommitmentType;
  capitalContributionRule: CapitalContributionRule | null;
  capitalContributionPercentage: number | null;
  fixedCapitalAmount: number | null;
  carrySettings: {
    carryPartnerName?: string | null;
    carryPartnerFundCommitment: number;
    capitalContributionPercentage: number | null;
    dayCount: CarriedInterestDayCountFormat;
    feeAllocationMethod: CarriedInterestFeeAllocationMethod;
    waterfallStructure: Array<WaterfallStructure>;
    carriedInterestFeeTemplates: Array<
      CarriedInterestFeeTemplate & { isInUse: boolean }
    >;
  };
  defaultAccountMappings: Array<AccountMapping>;
  onboardingSettings: {
    fundraiseTarget: number;
    targetCloseDate: CalendarDayInterface | null;
    requestBankDetails: boolean;
    minimumCommitmentSize: number;
    generalCommitmentInstructions: string;
    investorClassificationSettings: Array<{
      classificationFlow: ClassificationFlow;
      availableClassificationTypeIds: Array<string>;
      requiredTestResult: number | null;
    }>;
    defaultInternationalClassificationFlow: ClassificationFlow;
    requireAllSelectedStatuses: boolean;
    requireInvestorExperienceTesting: boolean;
    requireInvestorKnowledgeTesting: boolean;
    reviewSettings: {
      investorDetailsNeedsReview: boolean;
      classificationNeedsReview: boolean;
      taxDetailsNeedsReview: boolean;
      investorDetailsReviewerIds: Array<string>;
      classificationReviewerIds: Array<string>;
      taxDetailsReviewerIds: Array<string>;
    };
    enableCustomTaxRequests: boolean;
    customTaxRequestIds: Array<string>;
    kycRequestProcess: KycRequestProcess;
    customKycRequestIds: Array<string>;
    kybRequestProcess: KybRequestProcess;
    customKybRequestIds: Array<string>;
  };
  equalisationSettings: {
    dayCount: CarriedInterestDayCountFormat;
    equalisationInterestFeeTemplates: Array<
      EqualisationInterestFeeTemplate & { isInUse: boolean }
    >;
  };
}
